module.exports = __webpack_public_path__ + "static/media/send.8daa460e.png";